import { useMemo } from 'react';
import { differenceInCalendarDays, format, parseISO } from 'date-fns';

function parseToLocalDate(dateStr) {
  if (!dateStr) return null;
  const s = String(dateStr);
  // If it's date-only (yyyy-MM-dd), treat as local midnight (avoid UTC parsing of Date("yyyy-MM-dd"))
  const dateOnly = s.slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) {
    const [y, m, d] = dateOnly.split('-').map(Number);
    return new Date(y, m - 1, d, 0, 0, 0, 0);
  }
  // Otherwise fall back to native parse (for full ISO date-times)
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function useDays(startIso, endIso) {
  return useMemo(() => {
    if (!startIso || !endIso) return [];
    const start = parseToLocalDate(startIso);
    const end = parseToLocalDate(endIso);
    if (!start || !end) return [];
    const total = Math.max(1, differenceInCalendarDays(end, start) + 1);
    return Array.from({ length: total }, (_, i) => {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      return {
        iso: format(d, 'yyyy-MM-dd'),
        day: format(d, 'dd'),
        dow: format(d, 'EEE'),
        date: d,
      };
    });
  }, [startIso, endIso]);
}

// Normalize an ISO date-time string to a local date-only (midnight)
// to avoid timezone shifts.
export function toDateOnly(isoString) {
  if (!isoString) return null;
  try {
    const datePart = String(isoString).slice(0, 10);
    // Avoid `new Date('YYYY-MM-DD')` UTC parsing quirks across browsers/timezones.
    const [y, m, d] = datePart.split('-').map(Number);
    if (y && m && d) return new Date(y, m - 1, d, 0, 0, 0, 0);
    return new Date(datePart + 'T00:00:00');
  } catch (e) {
    try {
      const d = parseISO(isoString);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    } catch {
      return null;
    }
  }
}



